<template>
    <v-card outlined color="#F8F8F8" class="pl-4 ">
        <template>
            <v-row justify="center">
                <v-col cols="4" class="text-bold text-upper header-detail-order">
                    <span class="pl-6">Descripción</span>                    
                </v-col>
                <v-col cols="2" class="text-right text-bold text-upper header-detail-order">
                    <span class="pr-1">Cantidad</span>                    
                </v-col>
                <v-col cols="2" class="text-right text-bold text-upper header-detail-order">
                    <span class="pr-3">Precio</span>                    
                </v-col>
                <v-col cols="2" class="text-right text-bold text-upper header-detail-order">
                    <span class="pr-3">Descuento</span>                    
                </v-col>
                <v-col cols="2" class="text-right text-bold text-upper header-detail-order">
                    <span class="pr-8">Total</span>
                </v-col>
            </v-row>
        </template>
        <v-card-text class="pl-1 pt-0 content-detail-products wost-scroll">
            <v-card v-for="product in order.detail" :key="product.id" class="mb-2 pl-4 pt-3 pb-3 ">
                <template>
                    <v-row dense justify="center">
                        <v-col cols="4">
                            {{ product.name | uppercase() }}
                            <v-icon v-if="product.type_product === 'custom'" 
                                size="14"
                                class="ml-2"
                                color="blue"
                                @click="handleViewDetailProduct(product)">
                                far fa-eye
                            </v-icon>
                        </v-col>
                        <v-col cols="2" class="text-right">
                            <span class="mr-3">{{ product.quantity }}</span>                            
                        </v-col>
                        <v-col cols="2" class="text-right">
                            <span class="mr-3">{{ product.base_price | currency('S/ ') }}</span> 
                        </v-col>
                        <v-col cols="2" class="text-right">
                            <span class="mr-3">{{ product.discount_value | currency('S/ ') }}</span> 
                        </v-col>
                        <v-col cols="2" class="text-right">
                            <span class="mr-3">{{ product.subtotal | currency('S/ ') }}</span> 
                        </v-col>
                    </v-row>
                </template>
            </v-card>
        </v-card-text>

        <description-custom ref="descriptionCustom"></description-custom>
    </v-card>    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import DescriptionCustom from './DescriptionCustom';

export default {
    name: 'ListProducts',
    components: {
        DescriptionCustom
    },
    computed: {
        ...mapState('orders', [
            'order'
        ]),
    },
    methods: {
        ...mapActions('orders', [
            'selectOrder'
        ]),
        handleViewDetailProduct (product) {
            this.$refs.descriptionCustom.show(product);
        }
    }
}
</script>

<style>
.header-detail-order{
    font-size: .8rem;
}

.content-detail-products{
    height: 21vh;
    overflow-y: auto;
}

</style>